import CardDesignerControlPanel from './CardDesignerControlPanel';

export default CardDesignerControlPanel;
